!function($)
{
    'use strict';
    
    var debug = false;
    function log(msg)
    {
        if (debug)
        {
            console.log('QuarterYearPicker: ' + msg + '.');
        }
    }
    
    function QuarterYearPicker(anchor, options)
    {
        this.$anchor = $(anchor);
        
        this.options = this.getOptions(options);
        
        this.setYear = this.options.date.getFullYear();
        this.setQuarterYear = Math.ceil((this.options.date.getMonth() + 1) / 3);
        this.setYearBrowse = this.setYear;
        
        // q = Quartal, y = Jahr
        this.layer = 'q';
        
        this.build();

        this.update();
        
        this.registerEventHandler();
    }

    QuarterYearPicker.prototype =
    {
        defaults:
        {
            date: new Date(),
            startDate: null,
            endDate: null
        },

        constructor: QuarterYearPicker,

        getOptions: function(options)
        {
            return $.extend({}, this.defaults, options);
        },
        
        updateOptions: function(newOptions)
        {
        	this.options = $.extend(this.options, newOptions);
        },

        setStartDate: function(startDate)
        {
        	this.updateOptions({startDate: new Date(startDate)});
        	this.update();
        },
        
        setEndDate: function(endDate)
        {
        	this.updateOptions({endDate: new Date(endDate)});
        	this.update();
        },
        
        build: function()
        {
            this.$anchor.append(
            '<div class="datepicker datepicker-inline">' +
                '<div class="datepicker-years">'+
                    '<table class="table-condensed">'+
                        '<thead>'+
                            '<tr>'+
                                '<th class="prev">&laquo;</th>'+
                                '<th colspan="5" class="datepicker-switch"></th>'+
                                '<th class="next">&raquo;</th>'+
                            '</tr>'+
                        '</thead>' +
                        '<tbody>' +
                            '<tr>' +
                                '<td colspan="7"></td>' + 
                            '</tr>' + 
                        '</tbody>' +
                    '</table>'+
                '</div>'+
                '<div class="datepicker-quarter-years" style="display: block;">' +
                    '<table class="table-condensed">' +
                        '<thead>' +
                            '<tr>' +
                                '<th class="prev" style="visibility: visible;">&laquo;</th>' +
                                '<th colspan="5" class="datepicker-switch">'+
                                (function($this)
                                {
                                	var output = $this.setYear;

                                	return output;
                                }(this))
                                +'</th>' +
                                '<th class="next" style="visibility: visible;">&raquo;</th>' +
                            '</tr>' +
                        '</thead>' +
                        '<tbody>' +
                            '<tr>' +
                                '<td colspan="7">' +
                                    (function($this)
                                    {
                                        var output = '';
                                        
                                        for (var i = 1; i <= 4; i++)
                                        {
                                            var active = '';
                                            
                                            if (i === $this.setQuarterYear)
                                            {
                                                active = ' ' + 'active';
                                            }
                                            
                                            output += '<span class="quarter-year' + active + '">' + i + '</span>';
                                        }
                                        
                                        return output;
                                    }(this)) + 
                                '</td>' +
                            '</tr>' +
                        '</tbody>' +
                    '</table>' +
                '</div>' +
            '</div>');
        },
        
        update: function()
        {
            this.updateQuarterYearView();
        	this.updateYearView();
        	this.updateNav();
        },
        
        updateNav: function()
        {
        	this.$anchor.find('.datepicker').find('th.prev').css('visibility', 'visible');
        	this.$anchor.find('.datepicker').find('th.next').css('visibility', 'visible');

        	if (this.layer === 'q')
    		{
        		if (this.options.endDate != null && this.setYearBrowse == this.options.endDate.getFullYear())
    			{
        			this.$anchor.find('.datepicker').find('th.next').css('visibility', 'hidden');
    			}
        		
        		if (this.options.startDate != null && this.setYearBrowse == this.options.startDate.getFullYear())
    			{
        			this.$anchor.find('.datepicker').find('th.prev').css('visibility', 'hidden');
    			}
    		}
        	else
        	{
        		var head = this.$anchor.find('.datepicker-years').find('th.datepicker-switch').text();
        		var from = parseInt(head.split('-')[0], 10) - 1;
        		var to = parseInt(head.split('-')[1], 10) + 1;
        		
        		if (this.options.endDate !== null && from <= this.options.endDate.getFullYear() && this.options.endDate.getFullYear() <= to)
    			{
        			this.$anchor.find('.datepicker').find('th.next').css('visibility', 'hidden');
    			}

        		if (this.options.startDate !== null && from <= this.options.startDate.getFullYear() && this.options.startDate.getFullYear() <= to)
    			{
        			this.$anchor.find('.datepicker').find('th.prev').css('visibility', 'hidden');
    			}
        	}
        },
        
        updateQuarterYearView: function()
        {
        	var change = false;
            var output = '';
            var startQuarter = null;
            var startYear = null;
            var endQuarter = null;
            var endYear = null;

            if (this.options.startDate != null) {
                startQuarter = Math.ceil((this.options.startDate.getMonth() + 1) / 3);
                startYear = this.options.startDate.getFullYear();
            }

            if (this.options.endDate != null) {
                endQuarter = Math.ceil((this.options.endDate.getMonth() + 1 ) / 3);
                endYear = this.options.endDate.getFullYear();
            }

            // prüft ob aktuelles Datum valide
            if(!this.checkValid(moment(this.setYear + '-' + this.setQuarterYear, 'YYYY-Q'), startYear, startQuarter, endYear, endQuarter))
            {
                // Setzen von Jahr in der Übersicht (Jahresauswahl)
                if(startYear != null) {
                    this.setYear = startYear;
                    this.setYearBrowse = startYear;
                }

                // Setzen des Quartals
                if(startQuarter != null) {
                    this.setQuarterYear = startQuarter;
                }
                change = true;
            }

            for (var i = 1; i <= 4; i++)
            {
                var classes = '';

                // Iterationsdatum
                var newDate = moment(this.setYearBrowse + '-' + i, 'YYYY-Q');

                //prüfen ob Iterationsdatum valide => wenn nicht, disablen von Quartalen
                if(!this.checkValid(newDate, startYear, startQuarter, endYear, endQuarter))
                {
                    classes = "disabled";
                }

                // prüfen ob Zieldatum valide
                if (this.setYearBrowse === this.setYear && i === this.setQuarterYear)
                {
                	if (classes != 'disabled')
                	{
                		classes = 'active';
                	}
                }
                
                if (classes != '') {
                	classes = ' ' + classes;
                }
                
                output += '<span class="quarter-year' + classes + '">' + i + '</span>';
            }
            
            if (change) {
                this.$anchor.trigger(
                {
                    type: 'quarterYearChanged',
                    date: this.getSelected()
                });
            }
            
            this.$anchor.find('.datepicker-quarter-years').find('tbody').find('td').html(output);
        },

        checkValid: function(date, startYear, startQuarter, endYear, endQuarter)
        {
            // prüfen ob Iterationsdatum vor Startdatum
            if (startYear != null && startQuarter != null) {
                var startDate = moment(startYear + '-' + startQuarter, 'YYYY-Q');

                if(date.isBefore(startDate)) {
                    return false;
                }
            }

            // prüfen ob Iterationsdatum nach Enddatum
            if (endYear != null && endQuarter != null) {
                var endDate = moment(endYear + '-' + endQuarter, 'YYYY-Q');

                if(date.isAfter(endDate)) {
                    return false;
                }
            }

            return true;
        },
        
        updateYearView: function(browse)
        {
            var year = (this.options.date.getFullYear() - (this.options.date.getFullYear() % 10));
            var $this = this;
            
            if (!browse && year === this.setYearBrowse + 1)
            {
                year -= 10;
            }
            else if (!browse && year === this.setYearBrowse + 11)
            {
                year += 10;
            }
            
            var head = year;
            var spans = '<span class="year old' + (function() {
            	if ($this.options.startDate !== null && $this.options.startDate.getFullYear() > year) {
                	return ' ' + 'disabled';
                }
            	
            	return '';
            }()) + '">' + (year - 1) + '</span>';
            
            for (var i = 2; i <= 11; i++)
            {
                var classes = '';
                
                if (this.options.startDate !== null && this.options.startDate.getFullYear() > year) {
                	classes += ' ' + 'disabled';
                } else if (this.options.endDate !== null && this.options.endDate.getFullYear() < year) {
                	classes += ' ' + 'disabled';
                }
                
                if (year === this.setYear)
                {
                	classes += ' ' + 'active';
                }
                
                spans += '<span class="year' + classes + '">' + year++ + '</span>';
            }
            
            head += '-' + (year - 1);
            spans += '<span class="year new' + (function() {
            	if ($this.options.endDate !== null && $this.options.endDate.getFullYear() < year) {
                	return ' ' + 'disabled';
                }
            	
            	return '';
            }()) + '">' + year + '</span>';
            
            this.$anchor.find('.datepicker-years').find('th.datepicker-switch').html(head);
            this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').html(this.setYearBrowse);
            this.$anchor.find('.datepicker-years').find('tbody').find('td').html(spans);
        },
                
        getSelected: function()
        {
            return this.setYear + '-' + (((this.setQuarterYear - 1) * 3) + 1) + '-1'; 
        },
                
        registerEventHandler: function()
        {
            var $this = this;
            
            this.$anchor.on('click', 'span:not(.disabled)', function()
            {
                if ($(this).hasClass('quarter-year'))
                {
                    $this.$anchor.find('.datepicker-quarter-years').find('span').removeClass('active');
                    $(this).addClass('active');
                    
                    $this.setYear = parseInt($this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text(), 10);
                    $this.setQuarterYear = parseInt($(this).text(), 10);
                    
                    $this.$anchor.trigger(
                    {
                        type: 'quarterYearChanged',
                        date: $this.getSelected()
                    });
                }
                else
                {
                    $this.$anchor.find('.datepicker-years').find('span').removeClass('active');
                    $(this).addClass('active');
                    $this.setYear = parseInt($(this).text(), 10);
                    $this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text($this.setYear);
                    $this.layer = 'q';
                    $this.$anchor.find('.datepicker-quarter-years').css('display', 'block');
                    $this.$anchor.find('.datepicker-years').css('display', 'none');
                    $this.setYearBrowse = $this.setYear;
                    
                    if ($(this).hasClass('old'))
                    {
                        $this.options.date.setFullYear($this.options.date.getFullYear() - 10);
                    }
                    else if ($(this).hasClass('new'))
                    {
                        $this.options.date.setFullYear($this.options.date.getFullYear() + 10);
                    }
                    
                    $this.updateQuarterYearView();
                    $this.updateYearView();
                    $this.updateNav();
                }
            });
            
            this.$anchor.find('th.prev').click(function()
            {
                if ($this.layer === 'q')
                {
                    var prev = parseInt($this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text(), 10) - 1;
                    $this.$anchor.find('.datepicker-quarter-years').find('span').removeClass('active');
                    $this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text(prev);
                    
                    $this.options.date.setFullYear($this.options.date.getFullYear() - 1);
                    $this.setYearBrowse = prev;
                }
                else if ($this.layer === 'y')
                {
                    $this.options.date.setFullYear($this.options.date.getFullYear() - 10);
                }
                
                $this.updateQuarterYearView();
                $this.updateYearView(true);
                $this.updateNav();
            });
            
            this.$anchor.find('th.next').click(function()
            {
                if ($this.layer === 'q')
                {
                    var next = parseInt($this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text(), 10) + 1;
                    $this.$anchor.find('.datepicker-quarter-years').find('span').removeClass('active');
                    $this.$anchor.find('.datepicker-quarter-years').find('th.datepicker-switch').text(next);
                    
                    $this.options.date.setFullYear($this.options.date.getFullYear() + 1);
                    $this.setYearBrowse = next;
                }
                else if ($this.layer === 'y')
                {
                    $this.options.date.setFullYear($this.options.date.getFullYear() + 10);
                }
                
                $this.updateQuarterYearView();
                $this.updateYearView(true);
                $this.updateNav();
            });
            
            this.$anchor.find('.datepicker-switch').click(function()
            {
                if ($this.layer === 'q')
                {
                    $this.updateYearView();
                    
                    $this.$anchor.find('.datepicker-quarter-years').css('display', 'none');
                    $this.$anchor.find('.datepicker-years').css('display', 'block');
                    
                    $this.layer = 'y';
                    $this.updateNav();
                }
            });
        }
    };
    
    $.fn.quarterYearPicker = function(option, parameter)
    {
        var returnVal;
        var returnFn;
        
        returnVal = this.each(function()
        {
            var data = $(this).data('quarterYearPicker');
            var options = typeof option === 'object' && option;

            if (!data)
            {
                $(this).data('quarterYearPicker', (data = new QuarterYearPicker(this, options)));
            }

            if (typeof option === 'string')
            {
                returnFn = data[option](parameter);
            }
        });
        
        if (returnFn === undefined)
        {
            return returnVal;
        }
        else
        {
            return returnFn;
        }
    };

    $.fn.quarterYearPicker.Constructor = QuarterYearPicker;
}
(window.jQuery);